import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './Paragraph.module.scss';
import Linkify from 'react-linkify';
const Paragraph = ({ title, className, size = 2, linkify, onClick, fontFamily, color = 'black', onChange }) => {
    return (_jsx("p", Object.assign({ onClick: onClick, onChange: onChange, className: cn(className, styles.wrapper, styles[`hasSize-${size}`], styles[`hasColor-${color}`], styles[`hasFontFamily-${fontFamily}`]) }, { children: linkify ? _jsx(Linkify, { children: title }) : title })));
};
export default Paragraph;
